import hostAddress from './apiHostAddress';

const wsAddress = (function () {
  var url = "wss://"+hostAddress+"/";
  if (window.location.protocol !== "https:") {
    url = "ws://"+hostAddress+"/";
  }
  return url;
})();

export default wsAddress;